export default __webpack_public_path__ + "static/media/nature-ds.16ff8f0b.png";